import { z } from 'zod'

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'Pole jest wymagane' })
    .email({ message: 'Nieprawidłowy adres email' }),
  password: z.string().min(1, { message: 'Pole jest wymagane' }),
  rememberMe: z.boolean()
})

export type LoginInput = z.infer<typeof loginSchema>
